import { render, staticRenderFns } from "./StatusWiseTicketReport.vue?vue&type=template&id=f7a7a720&"
import script from "./StatusWiseTicketReport.vue?vue&type=script&lang=js&"
export * from "./StatusWiseTicketReport.vue?vue&type=script&lang=js&"
import style0 from "./StatusWiseTicketReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports